module.exports = __webpack_public_path__ + "static/media/externalLink.4e3d02ad.png";